/**
 * Unified Loader Export
 *
 * Provides easy access to all loading components
 */

export { PageLoader } from './PageLoader'
export { ComponentLoader } from './ComponentLoader'
export { Spinner } from './Spinner'

// Re-export as named exports for convenience
export { PageLoader as FullPageLoader } from './PageLoader'
export { ComponentLoader as InlineLoader } from './ComponentLoader'
